import { Grid, styled } from "@mui/material";

export const NewUserBlock = styled(Grid)(({ theme }) => ({
  display: "flex",
  gap: "10px",
}));
